export default __webpack_public_path__ + "static/media/CAT HOMBRES.470c1b66.svg";